import { configureStore } from '@reduxjs/toolkit';
import ReduxThunk, { ThunkAction } from 'redux-thunk';
import { AnyAction } from 'redux';

import api from '../api';
import helpCenter from './slices/helpCenter';
import user from './slices/user';
import modals from './slices/modals';
import notifications from './slices/notifications';
import tickets from './slices/tickets';
import chats from './slices/chats';
import faq from './slices/faq';
import releaseNotes from './slices/releaseNotes';
import search from './slices/search';
import appState from './slices/appState';

export const store = configureStore({
  reducer: {
    helpCenter,
    user,
    modals,
    notifications,
    tickets,
    chats,
    faq,
    releaseNotes,
    search,
    appState,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(ReduxThunk.withExtraArgument(api)),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type TThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, typeof api, AnyAction>;
